import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import compose from 'ramda/es/compose';
import { injectIntl } from 'react-intl';

import { Title, Container } from './contactUs.styles';
import { List } from '../../theme/layout';
import { ContactItem } from './contactItem/contactItem.component';
import messages from './contactUs.messages';


export class ContactUsComponent extends PureComponent {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    title: PropTypes.string,
    infoList: PropTypes.object,
    text1: PropTypes.string,
    icon1: PropTypes.object,
    text2: PropTypes.string,
    icon2: PropTypes.object,
    text3: PropTypes.string,
    icon3: PropTypes.object,
  };

  render() {
    const {
      intl,
      title,
      text1,
      icon1,
      text2,
      icon2,
      text3,
      icon3,
    } = this.props;

    return (
      <Container as="section">
        <Title>{title}</Title>
        <address>
          <List>
            <ContactItem text={text1} icon={icon1} description={intl.formatMessage(messages.address)} />
            <ContactItem text={text2} icon={icon2} description={intl.formatMessage(messages.email)} />
            <ContactItem text={text3} icon={icon3} description={intl.formatMessage(messages.phone)} />
          </List>
        </address>
      </Container>
    );
  }
}

export const ContactUs = compose(
  injectIntl,
)(ContactUsComponent);
